import React from 'react';
import PropTypes from 'prop-types';

export default class OEAnimationLoop extends React.PureComponent {

    constructor(props) {
        super(props);

        this.mounted = false;

        this._isRunning = this.props.isRunning;

        this.loop = this.loop.bind(this);
    }

    componentWillReceiveProps(nextProps) {
        if(nextProps.isRunning !== this.props.isRunning)     {
            this._isRunning = nextProps.isRunning;
            this.apply();
        }
    }

    componentDidMount()    {
        this.mounted = true;
        this.apply();
    }

    componentWillUnmount()    {
        if(this._isRunning)    this.stop();
        this.apply(false);
        this.mounted = false;
    }

    isRunning()   {
        return this._isRunning;
    }

    stop()  {
        this._isRunning = false;
        this.apply();
    }

    start() {
        this._isRunning = true;
        this.apply();
    }

    apply(run) {
        if(!this.mounted) return;
        let run_ = typeof(run) === 'boolean' ? run : this.isRunning();

        if((run_ && this._frameId) || (!run_ && !this._frameId))   return;

        if(run_)    {
            //console.log('requestAnimationFrame');
            this._frameId = window.requestAnimationFrame(this.loop);
        } else {
            //console.log('cancelAnimationFrame');
            window.cancelAnimationFrame(this._frameId);
            this._frameId = null;
            this.lastTime = null;
        }
    }

    loop(timestamp)  {
        let time = 0.001 * timestamp;
        let deltaTime = 0;
        if(typeof(this.lastTime) === 'number')  {
            deltaTime = time - this.lastTime;
        }

        this.lastTime = time;

        //console.log('loop - time: ' + time.toString() + ' deltaTime: ' + deltaTime.toString());

        this.props.onFramemove(time, deltaTime);

        this._frameId = window.requestAnimationFrame(this.loop);
    }

    render()    {
        return null;
    }
}

OEAnimationLoop.defaultProps = {
    isRunning: true,
    onFramemove: () => {}
};

OEAnimationLoop.propTypes = {
    isRunning: PropTypes.bool,
    onFramemove: PropTypes.func
};